export default __webpack_public_path__ + "static/media/image-upgrade.b9ed5689.jpg";